/* MERCADO 2.0 — product page behaviour (owner: commerce components, Agent D). Modern Beauty Pop.
   Vanilla JS, one custom element per main product section.
   - shade/size radio groups → variant → hidden select[name=id] (+ change event for apps), URL ?variant=, price,
     stock line, add button label/state, Buy-it-now visibility, pickup, gallery image, sticky bar
   - product form submit → window.MC2.cart.add (falls back to the normal POST when MC2 is not there)
   - gallery: scroll-snap track, thumbnails + counter, full-screen viewer (native pinch-zoom)
   - description clamp ("read more"), sticky add bar on phones
*/
(function () {
  'use strict';
  if (customElements.get('mc2-product-page')) return;

  function parse(el) { try { return el ? JSON.parse(el.textContent) : null; } catch (e) { return null; } }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  class Mc2ProductPage extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;
      this.variants = parse(this.querySelector('[data-mc2-variants]')) || [];
      this.str = parse(this.querySelector('[data-mc2-strings]')) || {};
      this.shadeIndex = Number(this.dataset.shadeIndex);
      this.form = this.querySelector('form[action*="/cart/add"]');
      this.select = this.querySelector('[data-mc2-variant-select]');
      this.sets = [].slice.call(this.querySelectorAll('[data-mc2-picker]'));
      this.addBtn = this.querySelector('[data-mc2-add-btn]');
      this.addLabel = this.querySelector('[data-mc2-add-label]');
      this.msg = this.querySelector('[data-mc2-form-error]');
      this.qty = this.querySelector('[data-mc2-qty] input');
      this.current = this.findCurrent();

      this.initPicker();
      this.initForm();
      this.initQty();
      this.initGallery();
      this.initDesc();
      this.initSticky();
      if (this.current) this.paintVariant(this.current, false);
    }

    /* ---------------- variants ---------------- */
    findCurrent() {
      if (!this.select || !this.select.value) return null;
      var id = Number(this.select.value);
      return this.variants.filter(function (v) { return v.id === id; })[0] || null;
    }
    chosen() {
      return this.sets.map(function (set) {
        var r = set.querySelector('input[data-mc2-opt]:checked');
        return r ? r.value : null;
      });
    }
    match(values) {
      if (values.some(function (v) { return v === null; })) return null;
      return this.variants.filter(function (v) {
        return v.options.every(function (o, i) { return o === values[i]; });
      })[0] || null;
    }

    initPicker() {
      var self = this;
      this.sets.forEach(function (set) {
        set.addEventListener('change', function (e) {
          if (!e.target.matches('input[data-mc2-opt]')) return;
          var cur = set.querySelector('[data-mc2-current]');
          if (cur) { cur.textContent = e.target.value; cur.classList.remove('is-empty'); }
          /* image swatches are extra labels for the same radios: mirror the checked state */
          set.querySelectorAll('[data-mc2-swi]').forEach(function (l) { l.classList.toggle('is-selected', l.getAttribute('data-mc2-swi') === e.target.id); });
          var group = self.querySelector('[data-mc2-picker-group]');
          if (group) group.classList.remove('is-prompt');
          self.onOptionsChange();
        });
      });
      if (this.sets.length > 1) this.markCombos();
    }

    /* with 2+ options, mark values that cannot be bought with the other current choices (still selectable) */
    markCombos() {
      var values = this.chosen(), vars = this.variants;
      this.sets.forEach(function (set, si) {
        set.querySelectorAll('input[data-mc2-opt]').forEach(function (input) {
          if (input.hasAttribute('data-sold')) return;
          var ok = vars.some(function (v) {
            if (!v.available || v.options[si] !== input.value) return false;
            return values.every(function (val, i) { return i === si || val === null || v.options[i] === val; });
          });
          var lab = input.nextElementSibling;
          if (lab) lab.classList.toggle('is-clash', !ok);
          var img = set.querySelector('[data-mc2-swi="' + input.id + '"]');
          if (img) img.classList.toggle('is-clash', !ok);
        });
      });
    }

    onOptionsChange() {
      if (this.sets.length > 1) this.markCombos();
      var values = this.chosen();
      var v = this.match(values);
      this.current = v;
      if (v) {
        this.paintVariant(v, true);
      } else {
        this.paintIncomplete(values);
      }
    }

    paintIncomplete(values) {
      var missing = values.indexOf(null);
      var allChosen = missing === -1;
      this.setButton(allChosen ? this.str.comboUnavailable : (missing === this.shadeIndex ? this.str.chooseShade : this.str.chooseOption), allChosen, true);
      this.toggleDynamic(false);
      this.toggleNotify(false);
    }

    paintVariant(v, userAction) {
      // the select apps read
      if (this.select && String(this.select.value) !== String(v.id)) {
        var opt = this.select.querySelector('option[value="' + v.id + '"]');
        if (opt) { opt.disabled = false; this.select.value = String(v.id); opt.disabled = !v.available; }
        this.select.dispatchEvent(new Event('change', { bubbles: true }));
      }
      // button
      if (v.available) this.setButton(v.add, false, false, true);
      else this.setButton(this.str.comboSoldOut, true, false);
      this.toggleDynamic(v.available);
      this.toggleNotify(!v.available, v);
      // price
      var priceWrap = this.querySelector('[data-mc2-price-wrap]');
      if (priceWrap && v.price_html) priceWrap.innerHTML = v.price_html;
      // stock
      var stock = this.querySelector('[data-mc2-stock]');
      if (stock) {
        stock.textContent = v.stock;
        stock.classList.toggle('is-out', !v.available);
        if (v.max) stock.setAttribute('data-low', ''); else stock.removeAttribute('data-low');
      }
      // quantity limit (only when we know a small tracked stock)
      if (this.qty) {
        if (v.max) { this.qty.max = v.max; if (Number(this.qty.value) > v.max) this.qty.value = v.max; }
        else this.qty.removeAttribute('max');
        this.syncQty();
      }
      // pickup
      var pk = this.querySelector('pickup-availability');
      if (pk && userAction) {
        pk.dataset.variantId = v.id;
        if (v.available && typeof pk.fetchAvailability === 'function') { pk.setAttribute('available', ''); pk.fetchAvailability(v.id); }
        else { pk.removeAttribute('available'); pk.innerHTML = ''; }
      }
      // URL
      if (userAction && window.history && history.replaceState) {
        try {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', v.id);
          history.replaceState(history.state, '', url.toString());
        } catch (e) {}
      }
      // gallery
      if (userAction && v.media) this.goToMedia(v.media);
      // sticky
      this.paintSticky(v);
      if (userAction) {
        this.hideMsg();
        this.dispatchEvent(new CustomEvent('mc2:variant:change', { bubbles: true, detail: { variant: v } }));
      }
    }

    setButton(label, disabled, isPrompt, isHtml) {
      this._prompt = !!isPrompt;
      if (this.addLabel) {
        if (isHtml) this.addLabel.innerHTML = label; else this.addLabel.textContent = label;
      }
      if (this.addBtn) { this.addBtn.disabled = !!disabled; this.addBtn.classList.toggle('is-prompt', !!isPrompt); }
      if (this.stickyBtn) {
        /* no shade yet: the bar's button turns secondary "اختاري اللون أولاً" and scrolls to the picker */
        if (isPrompt) this.stickyBtn.textContent = this.shadeIndex > -1 ? this.str.chooseShadeFirst : this.str.chooseOptionFirst;
        else if (isHtml) this.stickyBtn.innerHTML = label; else this.stickyBtn.textContent = label;
        this.stickyBtn.disabled = !!disabled;
        this.stickyBtn.classList.toggle('is-prompt', !!isPrompt);
      }
    }

    toggleNotify(show, v) {
      var n = this.querySelector('[data-mc2-notify]');
      if (!n) return;
      n.hidden = !show;
      var body = n.querySelector('[data-mc2-notify-body]');
      if (body && v && body.dataset.template) {
        var label = this.str.multi === true ? this.str.productTitle : this.str.productTitle + ' — ' + v.options.join(' / ');
        body.value = body.dataset.template.replace('%P%', label);
      }
    }

    toggleDynamic(show) {
      var d = this.querySelector('[data-mc2-dynamic]');
      if (d) d.hidden = !show;
    }

    /* ---------------- form ---------------- */
    initForm() {
      var self = this;
      if (!this.form) return;
      this.form.noValidate = true; /* the hidden select is `required` only for the no-JS fallback */
      if (this.current === null && this.addBtn && !this.addBtn.disabled) this._prompt = true;
      this.form.addEventListener('submit', function (e) {
        if (self._prompt || !self.select || !self.select.value) {
          e.preventDefault();
          self.promptChoice();
          return;
        }
        var cart = window.MC2 && window.MC2.cart;
        if (!cart || typeof cart.add !== 'function') return; // normal POST to /cart/add
        e.preventDefault();
        self.addToCart();
      });
    }

    addToCart() {
      var self = this, fd = new FormData(this.form);
      var item = { id: Number(fd.get('id')), quantity: Math.max(1, Number(fd.get('quantity')) || 1) };
      var props = {};
      fd.forEach(function (val, key) {
        var m = key.match(/^properties\[(.+)\]$/);
        if (m && typeof val === 'string' && val !== '') props[m[1]] = val;
      });
      if (Object.keys(props).length) item.properties = props;
      if (fd.get('selling_plan')) item.selling_plan = Number(fd.get('selling_plan'));
      var btns = [this.addBtn, this.stickyBtn].filter(Boolean);
      btns.forEach(function (b) { b.classList.add('is-loading'); b.setAttribute('aria-busy', 'true'); });
      this.hideMsg();
      Promise.resolve()
        .then(function () { return window.MC2.cart.add([item], { source: 'pdp' }); })
        .then(function () {
          if (self.msg) { self.msg.classList.add('is-ok'); self.msg.textContent = self.str.added; self.msg.hidden = false; }
          btns.forEach(function (b) { b.classList.remove('is-added'); void b.offsetWidth; b.classList.add('is-added'); setTimeout(function () { b.classList.remove('is-added'); }, 400); });
        })
        .catch(function (err) {
          self.showMsg((err && err.message) || self.str.error);
        })
        .then(function () {
          btns.forEach(function (b) { b.classList.remove('is-loading'); b.removeAttribute('aria-busy'); });
        });
    }

    promptChoice() {
      var group = this.querySelector('[data-mc2-picker-group]');
      this.showMsg(this.str.choosePrompt);
      if (!group) return;
      group.classList.add('is-prompt');
      var values = this.chosen(), idx = values.indexOf(null);
      var set = this.sets[idx > -1 ? idx : 0];
      if (set) {
        set.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'center' });
        var first = set.querySelector('input[data-mc2-opt]:not(:disabled)');
        if (first) setTimeout(function () { first.focus({ preventScroll: true }); }, reduceMotion ? 0 : 350);
      }
    }

    showMsg(text) { if (!this.msg) return; this.msg.classList.remove('is-ok'); this.msg.textContent = text; this.msg.hidden = false; }
    hideMsg() { if (this.msg) { this.msg.hidden = true; this.msg.textContent = ''; } }

    /* ---------------- quantity ---------------- */
    initQty() {
      var self = this;
      if (!this.qty) return;
      this.querySelectorAll('[data-mc2-qty-step]').forEach(function (b) {
        b.addEventListener('click', function () {
          var step = Number(b.getAttribute('data-mc2-qty-step'));
          var max = Number(self.qty.max) || Infinity;
          self.qty.value = Math.min(max, Math.max(1, (Number(self.qty.value) || 1) + step));
          self.syncQty();
        });
      });
      this.qty.addEventListener('change', function () {
        var max = Number(self.qty.max) || Infinity;
        self.qty.value = Math.min(max, Math.max(1, Math.floor(Number(self.qty.value)) || 1));
        self.syncQty();
      });
      this.syncQty();
    }
    syncQty() {
      if (!this.qty) return;
      var v = Number(this.qty.value) || 1, max = Number(this.qty.max) || Infinity;
      var dec = this.querySelector('[data-mc2-qty-step="-1"]'), inc = this.querySelector('[data-mc2-qty-step="1"]');
      if (dec) dec.disabled = v <= 1;
      if (inc) inc.disabled = v >= max;
    }

    /* ---------------- gallery ---------------- */
    initGallery() {
      var self = this;
      this.track = this.querySelector('[data-mc2-track]');
      if (!this.track) return;
      this.slides = [].slice.call(this.track.querySelectorAll('[data-mc2-slide]'));
      this.thumbs = [].slice.call(this.querySelectorAll('[data-mc2-thumb]'));
      this.counter = this.querySelector('[data-mc2-count-current]');
      if ('IntersectionObserver' in window && this.slides.length > 1) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (en) { if (en.isIntersecting) self.setActive(Number(en.target.dataset.index)); });
        }, { root: this.track, threshold: 0.6 });
        this.slides.forEach(function (s) { io.observe(s); });
      }
      this.thumbs.forEach(function (t) {
        t.addEventListener('click', function () { self.goToIndex(Number(t.getAttribute('data-mc2-thumb')), true); });
      });
      // keyboard: arrows move one slide (direction-aware)
      this.track.addEventListener('keydown', function (e) {
        if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;
        var rtl = getComputedStyle(self.track).direction === 'rtl';
        var fwd = (e.key === 'ArrowRight') !== rtl;
        e.preventDefault();
        self.goToIndex(Math.max(0, Math.min(self.slides.length - 1, (self.active || 0) + (fwd ? 1 : -1))), true);
      });
      // start on the variant's image without moving the page
      var initial = this.track.querySelector('[data-initial]');
      if (initial && initial !== this.slides[0]) this.goToIndex(Number(initial.dataset.index), false);
      // full-screen viewer
      this.viewer = this.querySelector('[data-mc2-viewer]');
      if (this.viewer && typeof this.viewer.showModal === 'function') {
        this.querySelectorAll('[data-mc2-zoom]').forEach(function (z) {
          z.addEventListener('click', function () { self.openViewer(z.getAttribute('data-mc2-zoom')); });
        });
        var close = this.viewer.querySelector('[data-mc2-viewer-close]');
        if (close) close.addEventListener('click', function () { self.viewer.close(); });
        this.viewer.addEventListener('close', function () { document.documentElement.style.overflow = ''; if (self._zoomFrom) self._zoomFrom.focus({ preventScroll: true }); });
      }
    }
    setActive(i) {
      this.active = i;
      if (this.counter) this.counter.textContent = String(i + 1);
      this.thumbs.forEach(function (t) {
        if (Number(t.getAttribute('data-mc2-thumb')) === i) { t.setAttribute('aria-current', 'true'); }
        else t.removeAttribute('aria-current');
      });
      var at = this.thumbs.filter(function (t) { return Number(t.getAttribute('data-mc2-thumb')) === i; })[0];
      if (at && at.parentElement && at.parentElement.parentElement) {
        var list = at.parentElement.parentElement, lr = list.getBoundingClientRect(), tr = at.getBoundingClientRect();
        if (tr.left < lr.left || tr.right > lr.right) list.scrollBy({ left: tr.left - lr.left - lr.width / 2 + tr.width / 2, behavior: reduceMotion ? 'auto' : 'smooth' });
      }
    }
    goToIndex(i, smooth) {
      var s = this.slides[i];
      if (!s || !this.track) return;
      var tr = this.track.getBoundingClientRect(), sr = s.getBoundingClientRect();
      this.track.scrollBy({ left: sr.left - tr.left, behavior: smooth && !reduceMotion ? 'smooth' : 'auto' });
      this.setActive(i);
    }
    goToMedia(mediaId) {
      if (!this.slides) return;
      var s = this.slides.filter(function (x) { return x.dataset.mediaId === String(mediaId); })[0];
      if (s) this.goToIndex(Number(s.dataset.index), true);
    }
    openViewer(index) {
      this._zoomFrom = document.activeElement;
      document.documentElement.style.overflow = 'hidden';
      this.viewer.showModal();
      var item = this.viewer.querySelector('[data-mc2-viewer-item="' + index + '"]');
      if (item) this.viewer.scrollTop = item.offsetTop - 8;
    }

    /* ---------------- description ---------------- */
    initDesc() {
      var body = this.querySelector('[data-mc2-desc-body]'), more = this.querySelector('[data-mc2-desc-more]');
      if (!body || !more) return;
      var lh = parseFloat(getComputedStyle(body).lineHeight) || 24;
      if (body.scrollHeight <= lh * 7.5) return; // short texts stay open
      body.classList.add('is-clamped');
      more.hidden = false;
      more.addEventListener('click', function () {
        var open = body.classList.toggle('is-clamped') === false;
        more.setAttribute('aria-expanded', String(open));
        more.textContent = open ? more.dataset.less : more.dataset.more;
      });
    }

    /* ---------------- sticky bar ---------------- */
    initSticky() {
      var self = this;
      this.sticky = this.querySelector('[data-mc2-sticky]');
      if (!this.sticky || !this.addBtn || !('IntersectionObserver' in window)) return;
      this.stickyBtn = this.sticky.querySelector('[data-mc2-sticky-btn]');
      if (this.addLabel && this.stickyBtn) {
        if (this._prompt) { this.stickyBtn.textContent = this.shadeIndex > -1 ? this.str.chooseShadeFirst : this.str.chooseOptionFirst; this.stickyBtn.classList.add('is-prompt'); }
        else this.stickyBtn.innerHTML = this.addLabel.innerHTML;
        this.stickyBtn.disabled = this.addBtn.disabled;
      }
      this.stickyBtn.addEventListener('click', function () {
        if (self._prompt || !self.form) { self.promptChoice(); return; }
        if (typeof self.form.requestSubmit === 'function') self.form.requestSubmit(self.addBtn);
        else self.addBtn.click();
      });
      var mq = window.matchMedia('(max-width: 989px)');
      this.sticky.hidden = false;
      var io = new IntersectionObserver(function (entries) {
        var en = entries[0];
        var past = !en.isIntersecting && en.boundingClientRect.top < 0;
        self.sticky.classList.toggle('is-visible', past && mq.matches);
        self.sticky.setAttribute('aria-hidden', String(!(past && mq.matches)));
        self.sticky.inert = !(past && mq.matches);
      });
      io.observe(this.addBtn);
    }
    paintSticky(v) {
      if (!this.sticky) return;
      var name = this.sticky.querySelector('[data-mc2-sticky-name]');
      var price = this.sticky.querySelector('[data-mc2-sticky-price]');
      /* caption: "<shade> · متوفر" */
      if (name) name.innerHTML = (this.variants.length > 1 ? '<bdi>' + esc(v.label) + '</bdi> · ' : '') + esc(v.stock);
      if (price && v.bar_html) price.innerHTML = v.bar_html;
    }
  }

  customElements.define('mc2-product-page', Mc2ProductPage);

  /* recommendations: fetched once when near the viewport (section rendering), hidden if empty */
  if (!customElements.get('mc2-product-recs')) {
    customElements.define('mc2-product-recs', class extends HTMLElement {
      connectedCallback() {
        if (this._ready || !this.dataset.url) return;
        this._ready = true;
        if (!this.hasAttribute('data-pending')) return; /* already rendered (or nothing to show) */
        var self = this;
        var load = function () {
          fetch(self.dataset.url, { credentials: 'same-origin' })
            .then(function (r) { return r.ok ? r.text() : ''; })
            .then(function (html) {
              if (!html) return;
              var doc = new DOMParser().parseFromString(html, 'text/html');
              var fresh = doc.querySelector('mc2-product-recs');
              if (!fresh || !fresh.querySelector('.mc2-grid li')) { self.hidden = true; return; }
              self.innerHTML = fresh.innerHTML;
              self.removeAttribute('data-pending');
            })
            .catch(function () {});
        };
        if (!('IntersectionObserver' in window)) { load(); return; }
        var io = new IntersectionObserver(function (entries) {
          if (!entries[0].isIntersecting) return;
          io.disconnect();
          load();
        }, { rootMargin: '0px 0px 600px 0px' });
        io.observe(this);
      }
    });
  }
})();
